import angular from 'angular';
import { AnnouncementService } from './service/AnnouncementService.js';
import { announcementComponent } from './component/announcementComponent.js';

angular
	.module('sh.announcement', ['sh.zIndexTop'])
	.component('shAnnouncement', announcementComponent())
	.service('Announcement', AnnouncementService);
